import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69eb50b863911b0014f7c1e9/thefacility/src/app/progress-trends/page.tsx");
